
import React from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Lock, User } from "lucide-react";
import { ProfileForm } from "./ProfileForm";
import { PasswordForm } from "./PasswordForm";
import { AccountManagement } from "./AccountManagement";

export function SettingsTabs() {
  return (
    <Tabs defaultValue="profile">
      <TabsList className="w-full mb-4">
        <TabsTrigger value="profile" className="flex-1">
          <User className="mr-2 h-4 w-4" />
          Profile
        </TabsTrigger>
        <TabsTrigger value="security" className="flex-1">
          <Lock className="mr-2 h-4 w-4" />
          Security
        </TabsTrigger>
      </TabsList>
      
      <TabsContent value="profile">
        <ProfileForm />
      </TabsContent>
      
      <TabsContent value="security">
        <PasswordForm />
        <div className="mt-6">
          <AccountManagement />
        </div>
      </TabsContent>
    </Tabs>
  );
}
